// Hook que controla o tema "Copa do Mundo Brasil" do cardápio público.
// - Lê o setting `cardapio_theme` do tenant via GET /api/settings (público)
// - Permite togglar via POST /api/settings (admin)
// - Quando `apply: true`, anexa/remove classe `theme-copa-brasil` no <html>
//   pra CSS overrides do tema (cores Brasil) entrarem em vigor.
import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = "/api";
const SETTING_KEY = "cardapio_theme";
const COPA_VALUE = "copa-brasil";
const HTML_CLASS = "theme-copa-brasil";

// ── ISOLAMENTO DA FEATURE (kill-switch único) ──────────────────────────────
// Modo Torcida / Copa CONGELADO após a Copa do Mundo 2026. Enquanto `false`,
// a feature inteira fica 100% inerte:
//   - TODOS os estabelecimentos ficam OFF, independente do valor salvo em
//     settings.cardapio_theme no banco (o hook nem lê o setting).
//   - O switch some da Visão Geral (CopaBanner retorna null).
//   - O cardápio público não aplica classe/overlay/ribbon (copa.active = false).
// Próxima Copa (2030): trocar pra `true` e revalidar — passo a passo no README
// desta pasta. NÃO apagar os arquivos; a feature foi isolada, não removida.
export const COPA_ENABLED = false;

export function useCopaTheme(opts = {}) {
  const [active, setActive] = useState(false);
  // Feature congelada: nada a carregar, não deixa consumidores em estado de loading.
  const [loading, setLoading] = useState(COPA_ENABLED);

  useEffect(() => {
    if (!COPA_ENABLED) return; // congelado: não consulta /settings
    let alive = true;
    axios
      .get(`${API}/settings`)
      .then((r) => {
        if (alive) setActive(r.data?.[SETTING_KEY] === COPA_VALUE);
      })
      .catch(() => {})
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    if (!COPA_ENABLED || !opts.apply) return; // congelado: nunca aplica o tema no <html>
    const html = document.documentElement;
    if (active) html.classList.add(HTML_CLASS);
    else html.classList.remove(HTML_CLASS);
    return () => html.classList.remove(HTML_CLASS);
  }, [active, opts.apply]);

  const toggle = useCallback(async (next) => {
    if (!COPA_ENABLED) return; // congelado: switch inerte, não grava setting
    setActive(next); // optimistic
    try {
      await axios.post(`${API}/settings`, {
        [SETTING_KEY]: next ? COPA_VALUE : "default",
      });
    } catch {
      setActive(!next); // revert
    }
  }, []);

  // `active` sempre false enquanto congelado (nenhum setActive roda acima).
  return { active: COPA_ENABLED && active, loading, toggle };
}
